/* eslint-disable array-bracket-newline */
/**
 * Imagine that we have table less than widget width
 * in this case we can offer customer to upscale table
 */
import { useEffect, useState } from 'react';
import {
  firstColumnGap,
  otherColumnsGap,
  scrollbarWidth,
} from './DesktopTable';

const getColumnWidth = (index: number, initialWidth: number) => {
  let width = initialWidth;
  if (index) {
    width = width < otherColumnsGap ? otherColumnsGap : width;
  } else {
    width = width < firstColumnGap ? firstColumnGap : width;
  }
  return width;
};

const getUpdatedColumns = (
  columns: any,
  initialTableWidth: number,
  initialTotalColumnsWidth: number
) => {
  let ratio = initialTableWidth / initialTotalColumnsWidth;
  let tableWidth = initialTableWidth;
  let totalColumnsWidth = initialTotalColumnsWidth;
  const updatedColumns = columns.reduce(
    (acc: any, column: any, index: number) => {
      const width = getColumnWidth(index, column.width);
      const updatedWidth = width * ratio;
      if (index) {
        if (updatedWidth < otherColumnsGap) {
          tableWidth -= otherColumnsGap;
          totalColumnsWidth -= width;
          ratio = tableWidth / totalColumnsWidth;
          return {
            ...acc,
            [column.id]: otherColumnsGap,
          };
        }
      } else {
        if (updatedWidth < firstColumnGap) {
          tableWidth -= firstColumnGap;
          totalColumnsWidth -= width;
          ratio = tableWidth / totalColumnsWidth;
          return {
            ...acc,
            [column.id]: firstColumnGap,
          };
        }
      }
      tableWidth -= updatedWidth;
      totalColumnsWidth -= width;
      ratio = tableWidth / totalColumnsWidth;
      return {
        ...acc,
        [column.id]: updatedWidth,
      };
    },
    {}
  );
  return updatedColumns;
};

const useUpscale = (
  tableWidth: number,
  columns: any,
  headerGroups: any,
  dispatch: any,
  tableKey: string,
  rememberColWidth: boolean
) => {
  const [upscale, setUpscale] = useState<boolean>(false);
  const [group] = headerGroups;
  const totalColumnsWidth = group?.headers.reduce(
    (acc: number, header: any, index: number) => {
      return acc + getColumnWidth(index, header.width);
    },
    0
  );

  useEffect(() => {
    if (totalColumnsWidth) {
      const atLeastOneColumn = !!group;
      const isSameWidth =
        Math.round(totalColumnsWidth) ===
        Math.round(tableWidth - scrollbarWidth); // 0.99 is 99% of parent's width
      setUpscale(atLeastOneColumn && !isSameWidth);
    }
  }, [totalColumnsWidth, tableWidth, group]);

  const handleUpscale = () => {
    if (rememberColWidth) {
      const updated = getUpdatedColumns(
        group.headers,
        tableWidth - scrollbarWidth,
        totalColumnsWidth
      );
      dispatch({
        type: 'fitMaxWidth',
        payload: updated,
      });
      localStorage.setItem(tableKey, JSON.stringify(updated));
    } else {
      const filteredColumns = columns.filter((column: any) =>
        group?.headers.some((header: any) => header.id === column.id)
      );
      const innerInitialWidth = filteredColumns.reduce(
        (acc: number, column: any) => acc + column.width,
        0
      );

      if (tableWidth && innerInitialWidth) {
        const ratio = (tableWidth - scrollbarWidth) / innerInitialWidth;
        const updated: any = filteredColumns.reduce(
          (acc: any, column: any) => ({
            ...acc,
            [column.id]: column.width * ratio,
          }),
          {}
        );
        dispatch({
          type: 'fitMaxWidth',
          payload: updated,
        });
      }
    }
  };

  return {
    totalColumnsWidth,
    upscale,
    handleUpscale,
  };
};

export default useUpscale;
